import { Injectable } from '@angular/core';
import { Database, ref, push, set, get, child } from '@angular/fire/database';
import { InterestedDriver } from '../models/driver.model';

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  constructor(private database: Database) { }

  /**
   * Save a new interested driver to Firebase Realtime Database
   */
  async saveInterestedDriver(driverData: InterestedDriver): Promise<string> {
    try {
      const driversRef = ref(this.database, 'interestedDrivers');
      const newDriverRef = push(driversRef);
      
      await set(newDriverRef, driverData);
      
      return newDriverRef.key!; // Returns the generated ID
    } catch (error) {
      console.error('Error saving driver data:', error);
      throw error;
    }
  }

  /**
   * Get all interested drivers
   */
  async getAllInterestedDrivers(): Promise<any> {
    try {
      const driversRef = ref(this.database, 'interestedDrivers');
      const snapshot = await get(driversRef);
      
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting drivers data:', error);
      throw error;
    }
  }

  /**
   * Get a specific driver by ID
   */
  async getDriverById(driverId: string): Promise<InterestedDriver | null> {
    try {
      const driverRef = ref(this.database, `interestedDrivers/${driverId}`);
      const snapshot = await get(driverRef);
      
      if (snapshot.exists()) {
        return snapshot.val() as InterestedDriver;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting driver data:', error);
      throw error;
    }
  }
}
